/**
 * Времення функция, маппит массив строк с услугами в объекты с рандомным параметром best
 * @param {String[]} facilities
 * @param {Boolean} setRandomBest
 * @returns {Object[]}
 */

const best = (setRandomBest, length) =>
  length > 5 && setRandomBest ? Math.round(Math.random() * 10) > 5 : false;

const transformAnyFacilities = ({
  items,
  setRandomBest,
  filterComparator,
  mapper,
}) => {
  if (!items) {
    return null;
  }

  const { length } = items;

  // сервер возвращает массив с пустыми строками для незаполненного блока удобств
  // отфильтруем их
  const filteredItems = items.filter(filterComparator);

  if (!filteredItems.length) {
    return null;
  }

  return filteredItems.map((item) => ({
    ...mapper(item),
    best: best(setRandomBest, length),
  }));
};

export const transformFacilities = (items, setRandomBest = false) =>
  transformAnyFacilities({
    items,
    setRandomBest,
    filterComparator: (item) => Boolean(item),
    mapper: (item) => ({
      text: item,
    }),
  });

export const transformFacilitiesWithIcons = (items, setRandomBest = false) =>
  transformAnyFacilities({
    items,
    setRandomBest,
    filterComparator: (item) => Boolean(item.name),
    mapper: (item) => ({
      text: item.name,
      icon: item.group_identifier,
    }),
  });
